import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Section.css";

import {
  FaPhone,
  FaWhatsapp,
  FaArrowRight,
  FaCheck,
  FaCouch,
  FaTools,
  FaStar,
  FaShieldAlt,
  FaPlay,
} from "react-icons/fa";

const Section = () => {
  const PHONE = "+919318333680";
  const WHATSAPP = "919318333680";

  return (
    <section className="rk-hero" id="home">

      {/* ================= BACKGROUND ================= */}

      <div className="rk-hero-bg-circle"></div>
      <div className="rk-hero-bg-line"></div>

      <div className="container">

        {/* ================= TOP LABEL ================= */}

        <div className="rk-hero-top">

          <div className="rk-hero-label">
            <span className="rk-label-dot"></span>
            PREMIUM SOFA CRAFTSMANSHIP
          </div>

          <div className="rk-hero-location">
            <FaCouch />
            Serving Noida & Nearby Areas
          </div>

        </div>


        {/* ================= MAIN HERO ================= */}

        <div className="rk-hero-main">

          {/* ================= LEFT CONTENT ================= */}

          <div className="rk-hero-content">

            <div className="rk-small-heading">
              <span>01</span>
              SOFA REPAIR & RESTORATION
            </div>


            <h1>
              Restore.
              <br />
              Refresh.
              <br />
              <span>Relax.</span>
            </h1>


            <p className="rk-hero-description">
              Give your old sofa a fresh new look with professional repair,
              upholstery, foam replacement and restoration services.
              Skilled workmanship delivered with care at your doorstep.
            </p>


            {/* ================= ACTIONS ================= */}

            <div className="rk-hero-actions">

              <a
                href={`tel:${PHONE}`}
                className="rk-primary-btn"
              >
                <span className="rk-btn-icon">
                  <FaPhone />
                </span>

                <span className="rk-btn-content">
                  <small>CALL FOR SERVICE</small>
                  <strong>Book a Visit</strong>
                </span>

                <FaArrowRight className="rk-btn-arrow" />
              </a>


              <a
                href={`https://wa.me/${WHATSAPP}?text=Hi%2C%20I%20need%20sofa%20repair%20service`}
                target="_blank"
                rel="noopener noreferrer"
                className="rk-whatsapp-btn"
              >
                <FaWhatsapp />
                WhatsApp Us
              </a>

            </div>


            {/* ================= TRUST ITEMS ================= */}

            <div className="rk-trust-row">

              <div className="rk-trust-item">
                <span>
                  <FaCheck />
                </span>
                <p>Doorstep Service</p>
              </div>

              <div className="rk-trust-item">
                <span>
                  <FaCheck />
                </span>
                <p>Quality Materials</p>
              </div>

              <div className="rk-trust-item">
                <span>
                  <FaCheck />
                </span>
                <p>Skilled Craftsmen</p>
              </div>

            </div>


            {/* ================= RATING ================= */}

            <div className="rk-rating">

              <div className="rk-rating-stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>

              <strong>4.9/5</strong>

              <span>
                Customer satisfaction
              </span>

            </div>

          </div>


          {/* ================= RIGHT VISUAL ================= */}

          <div className="rk-hero-visual">

            <div className="rk-image-number">
              <span>RK</span>
              <small>SOFA WORKS</small>
            </div>


            <div className="rk-image-frame">

              <img
                src="https://images.unsplash.com/photo-1555041469-a586c61ea9bc?q=80&w=1600&auto=format&fit=crop"
                alt="Premium Sofa Repair and Upholstery"
                className="rk-main-image"
              />

              <div className="rk-image-shade"></div>


              {/* IMAGE CAPTION */}

              <div className="rk-image-caption">

                <div className="rk-caption-icon">
                  <FaCouch />
                </div>

                <div>
                  <span>CRAFTED WITH CARE</span>
                  <strong>Complete Sofa Solutions</strong>
                </div>

              </div>

            </div>


            {/* ================= EXPERIENCE CARD ================= */}

            <div className="rk-experience-card">

              <div className="rk-experience-number">
                18<span>+</span>
              </div>

              <div className="rk-experience-text">
                <strong>Years</strong>
                <span>of Experience</span>
              </div>

              <FaTools className="rk-experience-icon" />

            </div>


            {/* ================= QUALITY CARD ================= */}

            <div className="rk-quality-card">

              <div className="rk-quality-icon">
                <FaShieldAlt />
              </div>

              <div>
                <strong>Premium Finish</strong>
                <span>Built to Last</span>
              </div>

            </div>


            {/* ================= PLAY / INSPECTION ================= */}

            <div className="rk-inspection-card">

              <div className="rk-play">
                <FaPlay />
              </div>

              <div>
                <span>EXPERT SERVICE</span>
                <strong>Professional Inspection</strong>
              </div>

            </div>

          </div>

        </div>


        {/* ================= BOTTOM INFO ================= */}

        <div className="rk-bottom-info">

          <div className="rk-bottom-item">

            <span className="rk-bottom-number">
              01
            </span>

            <div>
              <strong>Sofa Repair</strong>
              <span>Frame & structure work</span>
            </div>

          </div>


          <div className="rk-bottom-item">

            <span className="rk-bottom-number">
              02
            </span>

            <div>
              <strong>Re-Upholstery</strong>
              <span>Fresh fabric & finishing</span>
            </div>

          </div>


          <div className="rk-bottom-item">

            <span className="rk-bottom-number">
              03
            </span>

            <div>
              <strong>Foam Replacement</strong>
              <span>Better comfort & support</span>
            </div>

          </div>


          <div className="rk-bottom-item rk-bottom-cta">

            <a href="#/">
              Get Free Quote
              <FaArrowRight />
            </a>

          </div>

        </div>

      </div>

    </section>
  );
};

export default Section;
